import { render, staticRenderFns } from "./msValidate.vue?vue&type=template&id=d2b56c0a"
import script from "./msValidate.vue?vue&type=script&lang=js"
export * from "./msValidate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports